import React from 'react'

export type TextInputProps = {
    placeholder?: string,
    isRequired?: boolean,
    [key: string]: any
}


const TextInput = (props: TextInputProps) => {

    return (<div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        position: "relative"
    }}>
        {props.prefix &&
            <span style={{position: "absolute", left:"10px"}}>{props.prefix}</span>
        }
        <input
            type='text'
            placeholder={`${props?.placeholder || ""}`}
            autoComplete='off'
            {...props}
        />
    </div>
    )
}
export default TextInput;
